import { render } from "./AuditLogActions.vue?vue&type=template&id=1571a43c"
import script from "./AuditLogActions.vue?vue&type=script&lang=js"
export * from "./AuditLogActions.vue?vue&type=script&lang=js"

import "./AuditLogActions.vue?vue&type=style&index=0&id=1571a43c&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__